import React from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../navBar/navBar';
import './header.css';
import { useAuth } from "../../context/AuthContext.js";

function TransportationIcon() {
  return (
    <svg viewBox="0 0 35.82 37.1" role="img" className="dot-ribbon-icon">
      <title>U.S. Department of Transportation</title>
      <desc>U.S. Department of Transportation Icon</desc>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-2"
            d="M4.46,6.35a8.38,8.38,0,0,1,8.15-2.94c2.71.55,4.26,2.77,4.78,5.43a6.31,6.31,0,0,1-2.75,6.79c-3.68,2.1-8,3.74-8.86,8.5A13.42,13.42,0,0,0,8.47,34.4C3.81,31.8,1.13,26.6.25,21.23A18,18,0,0,1,4.46,6.35"
          />
          <path
            className="cls-2"
            d="M14.41,36.71A8.65,8.65,0,0,1,7.85,30.9a6.51,6.51,0,0,1,2.13-7,5.85,5.85,0,0,1,7.05-1c3.61,2.23,7.17,5.31,11.56,3.64A12.82,12.82,0,0,0,35.81,19C36,24.49,33,29.5,29,33a16.57,16.57,0,0,1-14.55,3.72"
          />
          <path
            className="cls-2"
            d="M34.73,12.39a9.12,9.12,0,0,1-1.53,8.8c-1.79,2.17-4.42,2.47-6.91,1.63A6.18,6.18,0,0,1,21.92,17c0-4.35.81-9.1-2.8-12.17A12.51,12.51,0,0,0,9.05,2.33c4.47-2.92,10.27-2.89,15.22-1A17.36,17.36,0,0,1,34.73,12.39"
          />
        </g>
      </g>
    </svg>
  );
}

function Header() {
  const location = useLocation();
  const showNavBar = location.pathname !== '/login';
  const defined = (v) => v !== undefined && v !== null && v !== "";
  const {source, token, userState, email, roles} = useAuth();

  let user= "";

  if(defined(roles)){
    if(roles.includes("fcwdHelpDesk")){
      user=" - Help Desk"
    } else { user=" - State User"}
  }

  // Retrieve the email from sessionStorage
  //const email = sessionStorage.getItem('email');

  return (
    <>
      <div className="dot-ribbon">
        <div className="container">
          <a href="https://www.transportation.gov">
            <TransportationIcon />
            <span>United States Department of Transportation</span>
          </a>
        </div>
      </div>
      <div className="header sticky-top">
        <div className="container">
          <div className="header-content">
            <div className="header-logo"></div> {/* Logo is now a styled div */}
            {/* Display the email inside header-title */}
            <div style={{"font-size": "27px", "float": "right"}} className="header-title">Foreign Convictions and Withdrawal Database (FCWD) {user}</div>
            {/* <div className="header-welcome">Welcome {email}</div> */}
          </div>
          {showNavBar && <NavBar />}
        </div>
      </div>
    </>
  );
}

export default Header;
